import { render, staticRenderFns } from "./ListObjectTitle.vue?vue&type=template&id=2f20aa2f"
import script from "./ListObjectTitle.vue?vue&type=script&lang=js"
export * from "./ListObjectTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports